import React from 'react'
import PropTypes from 'prop-types'

import { Image } from '@chatterbug/aaron'

import TutorAvatarSkeleton from './TutorAvatarSkeleton'

const TutorAvatar = ({ avatarUrl, tutorName, size }) => {
  return (
    <TutorAvatarSkeleton
      size={size}
      avatarSection={
        <Image
          width="100%"
          height="100%"
          src={avatarUrl}
          borderRadius="full"
          alt={tutorName}
          sx={{ objectFit: 'cover' }}
        />
      }
    />
  )
}

TutorAvatar.propTypes = {
  avatarUrl: PropTypes.string.isRequired,
  tutorName: PropTypes.string.isRequired,
  size: PropTypes.oneOf(['large', 'small']),
}

export default TutorAvatar
